import axios from "axios";
import { API } from "@/lib/api";

export const portalApi = axios.create({ baseURL: `${API}/portale` });
export const mediaUrl = (token, postId, mediaId) => `${API}/portale/${token}/media/${postId}/${mediaId}`;
export const portalLink = (path) => `${window.location.origin}${path}`;
